import { render, staticRenderFns } from "./articleManageEdit.vue?vue&type=template&id=4f23f9e7"
import script from "./articleManageEdit.vue?vue&type=script&lang=js"
export * from "./articleManageEdit.vue?vue&type=script&lang=js"
import style0 from "./articleManageEdit.vue?vue&type=style&index=0&id=4f23f9e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports